import { Consumer } from '../internal/Consumer';
export function createConsumer(settings) {
  return new Consumer(settings.topic);
}